import { IInboxMessage, INormalizedInboxMessage } from "./inbox-message";
import { IInboxMessageDenormalizer } from "./inbox-message-denormalizer";
import { InboxMessageTitles } from "./inbox-message-titles";

export interface IPluginLoadedMessage extends IInboxMessage {
  readonly title: InboxMessageTitles.PluginLoaded;
}

export function createPluginLoadedMessage(pluginId: string): IPluginLoadedMessage {
  return { title: InboxMessageTitles.PluginLoaded, pluginId };
}

export const PluginLoadedMessageDenormalizer: IInboxMessageDenormalizer<IPluginLoadedMessage> = {
  createMessage: (message: INormalizedInboxMessage) => createPluginLoadedMessage(message.plugin_id),
  messageTitle: InboxMessageTitles.PluginLoaded,
};
